// React Dependencies
import React, { Component } from 'react';

// External Dependencies
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { toast } from 'react-toastify';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import {
  RadioGroup,
  Chip,
  TextField,
  Button,
  Radio,
  FormControlLabel,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Dialog,
  Checkbox,
  FormGroup,
  Typography,
  makeStyles,
  Tooltip,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { DropzoneArea } from 'material-ui-dropzone';
import DeleteOutlineIcon from '@material-ui/icons//DeleteOutline';
import LaunchIcon from '@material-ui/icons/Launch';
import CancelIcon from '@material-ui/icons/CancelOutlined';
import IconButton from '@material-ui/core/IconButton';
import FormControl from '@material-ui/core/FormControl';

// Internal Dependencies
import FixedCropper from '../global/image/FixedCropper';
import PageSuggestionField from '../common/suggestions/PageSuggestionField';
import OverLoading from '../global/OverLoading';

import Constants, { PayProcessor } from '../../common/constants';
import Colours from '../../styles/colours';
import Tagging from '../common/tagging';
import { Trim, convertDataURLtoBlob, StringToInteger, formatTag } from '../../common/util';
import { IfFalseThrowError, IfTrueThrowError, IsEmpty, IsMultipleUrl, IsString, IsValidHttpsUrl } from '../../common/checks';

import { addPage, getPage, updatePage, updatePageStatus, uploadPageImage, deletePageImage } from '../../actions/admin/pageAction';
import { getAddress } from '../../actions/admin/address';
import { getCategories } from '../../actions/admin/category';

const { PageType } = Constants;

const useStyles = (theme) => ({
  myDropZone: {
    position:        'relative',
    width:           '50%',
    height:          '10%',
    minHeight:       '20px',
    backgroundColor: '#f5f7fa',
    border:          0,
    boxShadow:       '0 1px 3px 1px rgba(0, 0, 0, .3)',
    borderRadius:    5,
    borderColor:     '#000000',
    cursor:          'pointer',
    boxSizing:       'border-box',
  },
  appBar: {
    position:        'relative',
    backgroundColor: '#2b957a',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex:       1,
  },
});

const useCheckboxGroupStyles = makeStyles({
  root: {
    display:       'flex',
    flexDirection: 'row',
  },
});

const SocialLinkInput = ({ title, state = '', onClick, onChange }) => (
  <div className="form-group">
    <Typography style={{ display: 'inline-block' }}>{title}</Typography>
    {state && !IsMultipleUrl(state) && (
      <Button
        onClick={() => {
          const url = state;
          const fullUrl = url.startsWith('http://') || url.startsWith('https://')
            ? url
            : `http://${url}`;
          window.open(fullUrl, '_blank');
        }}
        target="_blank"
        variant="outlined"
        color="secondary"
        style={{ border: `1px solid ${Colours.Primary}` }}
        size="medium"
        className="d-inline-block mb-2 ml-5"
      >
        <span style={{ color: Colours.Primary, marginRight: 5 }}>Open Link</span>
        <LaunchIcon style={{ color: Colours.Primary }} />
      </Button>
    )}
    {state && IsMultipleUrl(state) && (
      <Button
        variant="outlined"
        color="secondary"
        style={{ border: `1px solid ${Colours.Primary}` }}
        size="medium"
        className="d-inline-block mb-2 ml-5"
        onClick={onClick} // added onClick event to open modal
      >
        <span style={{ color: Colours.Primary, marginRight: 5 }}>View Links</span>
        <LaunchIcon style={{ color: Colours.Primary }} />
      </Button>
    )}
    <textarea
      className="form-control"
      name={_.lowerCase(title)}
      placeholder={['Facebook', 'Instagram'].includes(title) ? 'https://example.com\nhttps://monstyr.com' : 'https://example.com'}
      rows="5"
      value={state}
      onChange={onChange}
    />
  </div>
);

const SocialLinksModal = ({ title, state = '', toggleOff, open }) => (
  <Modal
    isOpen={open}
    toggle={toggleOff}
    size="lg"
    autoFocus={false}
  >
    <ModalHeader toggle={toggleOff}>{`View ${title} Links`}</ModalHeader>
    <ModalBody>
      {state.split('\n').map((url) => {
        const fullUrl = url.startsWith('http://') || url.startsWith('https://')
          ? url
          : `http://${url}`;
        return (
          <div className="mb-2" key={url}>
            <a
              href={fullUrl}
              target="_blank"
              rel="noreferrer"
              style={{ fontSize: 12 }}
            >
              {url}
            </a>
            <br />
          </div>
        );
      })}
    </ModalBody>
  </Modal>
);

const CheckboxGroup = ({ payProcessor, onChange }) => {
  const classes = useCheckboxGroupStyles();
  return (
    <div>
      <FormControl component="fieldset">
        <FormGroup classes={{  root: classes.root }}>
          {
            PayProcessor.map((processor) => (
              <FormControlLabel
                control={(
                  <Checkbox
                    checked={payProcessor[processor]}
                    onChange={() => { onChange(processor); }}
                    name={processor}
                    color="primary"
                  />
                )}
                label={processor}
              />
            ))
          }
        </FormGroup>
      </FormControl>
    </div>
  );
};

class pageInfo extends Component {
  constructor(props) {
    super(props);
    this.selectCategoryRef = null;
    this.dropZoneRef = null;
    this.state = {
      id:                       null,
      alert:                    false,
      loading:                  false,
      isUpdate:                 false,
      isParentRemovalModalOpen: false,
      categoryOptions:          [],
      selectedCategoryOptions:  [],

      selectedParent: null,

      openCropDialog:     false,
      preview:            false,
      currentFile:        null,
      uploadUrl:          '',
      src:                null,
      redirect:           false,
      openFacebookModal:  false,
      openInstagramModal: false,
      formData:           {
        parentId:                  null,
        parentName:                null,
        name:                      '',
        langZh:                    '',
        description:               '',
        website:                   '',
        facebook:                  '',
        instagram:                 '',
        categoryIds:               [],
        logo:                      '',
        type:                      Constants.PageType.Retailer,
        halal:                     Constants.HalalStatus.No,
        payProcessor:              PayProcessor.reduce((accumulator, current) => ({ ...accumulator, [current]: false }), {}),
        address:                   '',
        postalCode:                '',
        userTags:                  [],
        lat:                       '',
        lng:                       '',
        status:                    Constants.PageStatus.Pending,
        permanentlyClosed:         false,
        uniqueOpenHours:           [],
        enableMap:                 false,
        lastKDays:                 null,
        isViewFnb:                 false,
        isFastFood:                false,
        isConvStore:               false,
        isChainStore:              false,
        isOfficial:                false,
        prefixCode:                '',
        showAllPostsInLowLevelMap: false,
        tagSearchInMapEnabled:     false,
      },
    };
    this.minLogoRes = 200;
    this.maxLogoRes = 2000;

    this.handleSave = this.handleSave.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
  }

  componentDidMount() {
    if (this.props.match && this.props.match.params && this.props.match.params.id) {
      this.setState({ isUpdate: true });
    }

    const fetchPageData = async () => {
      if (this.props.match && this.props.match.params && this.props.match.params.id) {
        const page = await this.props.getPage(this.props.match.params.id);
        if (page) {
          const payProcessor = PayProcessor.reduce((accumulator, current) => ({ ...accumulator, [current]: page.payProcessor ? page.payProcessor.includes(current) : false }), {});
          this.setState({
            formData:
            {
              parentId:                  page.parentId ? page.parentId : null,
              name:                      page.name ? page.name : '',
              langZh:                    page.langZh ? Trim(page.langZh) : '',
              description:               page.description ? page.description : '',
              website:                   page.website ? page.website : '',
              facebook:                  page.facebook ? page.facebook : '',
              instagram:                 page.instagram ? page.instagram : '',
              categoryIds:               _.map(page.categories, 'id'),
              logo:                      page.logo ? page.logo : '',
              images:                    page.images ? page.images : [],
              type:                      page.type ? page.type : '',
              address:                   page.address ? page.address : null,
              postalCode:                page.postalCode ? page.postalCode : null,
              lat:                       page.lat ? page.lat : null,
              lng:                       page.lat ? page.lng : null,
              userTags:                  page.userTags || [],
              status:                    page.status ? page.status : Constants.PageStatus.Pending,
              permanentlyClosed:         page.permanentlyClosed,
              uniqueOpenHours:           page.uniqueOpenHours ? page.uniqueOpenHours : [],
              enableMap:                 page.enableMap,
              payProcessor,
              halal:                     page.halal,
              lastKDays:                 page.lastKDays,
              isViewFnb:                 page.isViewFnb,
              isFastFood:                page.isFastFood,
              isConvStore:               page.isConvStore,
              isChainStore:              page.isChainStore,
              isOfficial:                page.isOfficial,
              prefixCode:                page.prefixCode,
              giftEnabled:               page.giftEnabled,
              showAllPostsInLowLevelMap: page.showAllPostsInLowLevelMap,
              tagSearchInMapEnabled:     page.tagSearchInMapEnabled,
            },
            isHasKDays: !IsEmpty(page.lastKDays),
          }, () => {
            if (this.state.isUpdate && !IsEmpty(this.state.formData.parentId)) {
              this.fetchParentData(this.state.formData.parentId);
            }
          });
        }
      }

      const selectedOptions = [];
      const fetchCategoriesData = async () => {
        const categories = await this.props.getCategories();
        const categoryOptions = categories.map((category) => {
          if (this.props.match && this.props.match.params && this.props.match.params.id) {
            if (this.state.formData.categoryIds.includes(category.id)) {
              selectedOptions.push({
                value: category.id,
                label: category.name,
                group: category.group,
              });
            }
          }
          return {
            value: category.id,
            label: category.name,
            group: category.group,
          };
        });
        this.setState({ categoryOptions });
      };
      fetchCategoriesData();
      this.setState({ selectedCategoryOptions: selectedOptions });
    };
    fetchPageData();
  }

  fetchParentData = async (parentId) => {
    const parentData = await this.props.getPage(parentId);
    if (parentData) {
      this.setState((prevState) => ({
        selectedParent: { id: parentId, name: parentData.name },
        formData:       { ...prevState.formData, parentName: parentData.name },
      }));
    }
  }

  handleUpload = (files) => {
    if (files.length > 0) {
      /** Use the following code if we want to crop the uploaded image */
      this.setState({ openCropDialog: true, type: 'upload' }, () => {
        this.setState({ preview: false, currentFile: files[files.length - 1] }, () => {
          const reader = new FileReader();
          reader.addEventListener('load', () => {
            const img = new Image();
            img.src = reader.result;
            img.onload = () => {
              if (img.width < this.minLogoRes || img.height < this.minLogoRes) {
                toast.error('Image does not meet minimum resolution');
              } else if (img.width > this.maxLogoRes || img.height > this.maxLogoRes) {
                toast.error('Image resolution exceeds the maximum allowed size');
              } else {
                // upload to server
                const blob = convertDataURLtoBlob(reader.result);
                const file = new File([blob], 'image.png', { type: 'image/png' });
                this.setState({ src: reader.result });
              }
            };
          });
          reader.readAsDataURL(files[files.length - 1]);
        });
      });
    }
  }

  handleSave = async (file) => {
    if (file) {
      const formData = new FormData();
      formData.append('image', file);
      formData.append('imageType', Constants.ImageType.Logo);
      const cloudfrontLink = await this.props.uploadPageImage(this.props.match.params.id, formData);
      if (cloudfrontLink && cloudfrontLink.length > 0) {
        this.setState({
          formData: {
            ...this.state.formData,
            logo: cloudfrontLink,
          },
          openCropDialog: false,
          currentFile:    null,
        });

        toast.success('Image uploaded successfully.');
      } else {
        this.setState({ openCropDialog: false });
        toast.error('An unexpected error has occurred');
      }
    }
  }

  handleDelete = async () => {
    const response = await this.props.deletePageImage(this.props.match.params.id, this.state.formData.logo, 'logo');
    if (response) {
      this.setState({
        formData: {
          ...this.state.formData,
          logo: '',
        },
        alert: false,
      });
    } else {
      this.setState({ alert: false });
    }
  }

  handleClose = () => {
    this.setState({ openCropDialog: false, preview: true, currentFile: null, alert: false });
  }

  handleChangeCategoryOptions = (selectedOption) => {
    selectedOption = _.uniqBy(selectedOption, 'value');
    this.setState({
      selectedCategoryOptions: selectedOption,
      formData:
      {
        ...this.state.formData,
        categoryIds: _.map(selectedOption, 'value'),
      },
    });
  };

  handleChangeParentOptions = (selectedOption) => {
    let userTags = IsEmpty(this.state.formData.userTags) ? [] : this.state.formData.userTags;

    // remove previously selected's parent page name from userTags
    if (!_.isEmpty(this.state.selectedParent)) {
      const idx = userTags.indexOf(this.state.selectedParent.name);
      if (idx !== -1) {
        // found. Remove it
        userTags.splice(idx, 1);
      }
    }

    // makes sure the previously selected parent's tag is removed when changing the selectedParent
    if (!_.isEmpty(this.state.selectedParent) && !IsEmpty(this.state.selectedParent.name)) {
      const prevParentTag = formatTag(this.state.selectedParent.name);
      userTags = userTags.filter((tag) => tag !== prevParentTag);
    }

    // add new parent page name as user tag
    if (!IsEmpty(selectedOption)) {
      const parentPageTag = formatTag(selectedOption.name);
      if (!userTags.includes(parentPageTag)) {
        userTags.push(parentPageTag);
      }
    }

    this.setState({
      selectedParent: selectedOption,
      formData:       { ...this.state.formData, userTags },
    }, () => { console.log(this.state.formData); });
  };

  getSelectedCategoryOptionsValue = () => {
    if (this.state.selectedCategoryOptions && this.state.selectedCategoryOptions.length) { return this.state.selectedCategoryOptions.length; } else return '';
  };

  onChange = (e) => {
    if (e.target.name === 'type') {
      if (e.target.value !== 'View') {
        // cannot merge null value, this is the way to force it
        this.state.formData.lastKDays = null;
        this.setState({ formData: { ...this.state.formData }, isHasKDays: false });
      }
      if (e.target.value !== Constants.PageType.Mall) {
        this.setState({
          formData: {
            ...this.state.formData,
            [e.target.name]: e.target.value,
            postalCode:      '',
            address:         '',
            lat:             '',
            lng:             '',
          },
        });
      } else {
        this.setState({
          formData: {
            ...this.state.formData,
            [e.target.name]: e.target.value,
          },
        });
      }
    } else if (e.target.name === 'halal') {
      let tags = [...this.state.formData.userTags];

      if (e.target.value === Constants.HalalStatus.No) {
        tags = tags.filter((x) => x !== 'halal certified' && x !== 'muslim owned' && x !== 'halal');
      } else if (e.target.value === Constants.HalalStatus.MuslimOwned) {
        tags = tags.filter((x) => x !== 'halal certified');
        tags.push('muslim owned');
      } else {
        tags = tags.filter((x) => x !== 'muslim owned');
        tags.push('halal certified');
      }

      if (e.target.value === Constants.HalalStatus.MuslimOwned || e.target.value === Constants.HalalStatus.HalalCertified) {
        if (!tags.includes('halal')) tags.push('halal');
      }

      this.setState({
        formData: {
          ...this.state.formData,
          [e.target.name]: e.target.value,
          userTags:        tags,
        },
      });
    } else if (e.target.name === 'lastKDays') {
      this.setState({
        formData: {
          ...this.state.formData,
          [e.target.name]: e.target.value,
        },
        isHasKDays: true,
      });
    } else if (e.target.name === 'is-fast-food') {
      let tags = [...this.state.formData.userTags];

      if (!this.state.formData.isFastFood) {
        if (!tags.includes('fast food')) tags.push('fast food');
      } else {
        tags = tags.filter((x) => x !== 'fast food');
      }

      this.setState({
        formData: {
          ...this.state.formData,
          userTags:   tags,
          isFastFood: !this.state.formData.isFastFood,
        },
      });
    } else if (e.target.name === 'is-conv-store') {
      let tags = [...this.state.formData.userTags];

      if (!this.state.formData.isConvStore) {
        if (!tags.includes('convenience store')) tags.push('convenience store');
      } else {
        tags = tags.filter((x) => x !== 'convenience store');
      }
      this.setState({
        formData: {
          ...this.state.formData,
          userTags:    tags,
          isConvStore: !this.state.formData.isConvStore,
        },
      });
    } else if (e.target.name === 'is-chain-store') {
      this.setState({
        formData: {
          ...this.state.formData,

          isChainStore: !this.state.formData.isChainStore,
        },
      });
    } else if (e.target.name === 'is-official') {
      this.setState({
        formData: {
          ...this.state.formData,
          isOfficial: !this.state.formData.isOfficial,
        },
      });
    } else {
      this.setState({
        formData: {
          ...this.state.formData,
          [e.target.name]: e.target.value,
        },
      });
    }
  };

  onChangePostalCode = (e) => {
    this.setState({
      formData: {
        ...this.state.formData,
        postalCode: Trim(e.target.value),
      },
    }, async () => {
      const { postalCode } = this.state.formData;
      if (postalCode.length === 6) {
        this.setState({
          formData: {
            ...this.state.formData,
            address: null,
            lat:     null,
            lng:     null,
          },
        });

        this.props.getAddress(postalCode)
          .then((result) => {
            if (result) {
              this.setState({
                formData: {
                  ...this.state.formData,
                  address: result.address,
                  lat:     result.lat,
                  lng:     result.lng,
                },
              });
            } else {
              this.setState({
                formData: {
                  ...this.state.formData,
                  address: null,
                  lat:     null,
                  lng:     null,
                },
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.setState({
          formData: {
            ...this.state.formData,
            address: null,
            lat:     null,
            lng:     null,
          },
        });
      }
    });
  }

  onPrefixCodeChange = (e) => {
    const { value } = e.target;

    this.setState((prevState) => ({ formData: { ...prevState.formData, prefixCode: value } }));
  }

  onChangeEnableMap = (e) => this.setState({ formData: { ...this.state.formData, enableMap: e } })

  onChangeGiftEnabled = (e) => this.setState({ formData: { ...this.state.formData, giftEnabled: e } })

  onChangeIsViewFnb = (e) => this.setState({ formData: { ...this.state.formData, isViewFnb: e } });

  onChangeShowAllPostsInLowLevelMap = (e) => this.setState({ formData: { ...this.state.formData, showAllPostsInLowLevelMap: e } });

  onChangeTagSearchInMapEnabled = (e) => this.setState({ formData: { ...this.state.formData, tagSearchInMapEnabled: e } });

  onChangeKDaysCheckBox = (e) => {
    if (e.target.checked) {
      this.setState({ formData: { ...this.state.formData, lastKDays: '3' }, isHasKDays: e.target.checked });
    } else {
      this.setState({ formData: { ...this.state.formData, lastKDays: null }, isHasKDays: e.target.checked });
    }
  }

  onClickUrlInput = (e) => {
    if (e.target.value && e.target.value.startsWith('https')) {
      window.open(e.target.value, '_blank');
    }
  }

  preventSubmitOnEnter = (e) => {
    // we need both preventing default + checking keyCode to prevent submitting
    const { keyCode, target } = e;
    if (keyCode !== 13 || target instanceof HTMLTextAreaElement) {
      return;
    }
    e.preventDefault();
  }

  removeParentPage = async () => {
    try {
      const formattedParentName = formatTag(this.state.formData.parentName);
      IfTrueThrowError(
        !IsEmpty(this.state.formData.parentId) && this.state.formData.userTags.every((tag) => tag === formattedParentName),
        'Please add at least one more tag before removing the parent page, as removing the parent will also remove its associated tag',
      );

      this.setState({ loading: true });
      const page = await this.props.updatePage(this.props.match.params.id, { parentId: null });
      this.setState((prevState) => ({
        isParentRemovalModalOpen: false,
        selectedParent:           null,
        formData:                 { ...prevState.formData, userTags: page.userTags, parentId: null },
      }));
    } catch (err) {
      toast.error(err.message);
    } finally {
      this.setState({ loading: false });
    }
  }

  onSubmit = async (e) => {
    try {
      // *Used to auto-include the tag typed in 'Tags' but wasn't added in the list, and user click the 'Update' button.
      document.activeElement.blur();

      e.preventDefault();
      this.setState({ loading: true });
      let page = null;

      if ((this.state.formData.status === Constants.PageStatus.Live && IsEmpty(this.state.formData.address))
        && (this.state.formData.type === Constants.PageType.Mall || this.state.formData.type === Constants.PageType.HawkerCentre)) {
        this.setState({ loading: false });
        return toast.error(Constants.Error.PostalCodeIsInvalid);
      }

      if (this.state.formData.type === 'View' && this.state.isHasKDays && (IsEmpty(this.state.formData.lastKDays) || isNaN(StringToInteger(this.state.formData.lastKDays)) || StringToInteger(this.state.formData.lastKDays) < 1)) {
        this.setState({ loading: false });

        return toast.error(`"Display posts that will expire in" contains invalid value`);
      }

      const langZhTrimmed = Trim(this.state.formData.langZh, false, true);
      const nameTrimmed = Trim(this.state.formData.name, false, true);

      const payProcessorObj = this.state.formData.payProcessor;

      const selectedPayProcessors = Object.keys(payProcessorObj).filter((processor) => payProcessorObj[processor] === true).join(', ');

      const links = {
        website:   '',
        facebook:  '',
        instagram: '',
      };

      // Add check for valid url of website, instagram and facebook
      for (const key of Object.keys(links)) {
        if (key === 'website') {
          const trimmedLink = Trim(this.state.formData[key], false, false);

          if (trimmedLink !== '') {
            const isHttpsUrl = IsValidHttpsUrl(trimmedLink);
            IfFalseThrowError(isHttpsUrl, `URL for "${key}" must be a valid https URL`);
            links[key] = trimmedLink;
          }
        } else {
          const urls = this.state.formData[key].split(/\r?\n|\r|\n/g);
          _.map(urls, (url) => {
            const trimmedLink = Trim(url, false, false);

            if (trimmedLink !== '') {
              const isHttpsUrl = IsValidHttpsUrl(trimmedLink);
              IfFalseThrowError(isHttpsUrl, `URL for "${key}" must be a valid https URL`);
            }
          });
          links[key] = this.state.formData[key];
        }
      }

      if (this.state.isUpdate) {
        const payload = {
          type:                      this.state.formData.type,
          langZh:                    langZhTrimmed,
          description:               this.state.formData.description,
          categoryIds:               this.state.formData.categoryIds,
          website:                   links.website,
          facebook:                  links.facebook,
          instagram:                 links.instagram,
          userTags:                  this.state.formData.userTags,
          postalCode:                this.state.formData.postalCode,
          address:                   this.state.formData.address,
          lat:                       this.state.formData.lat,
          lng:                       this.state.formData.lng,
          payProcessor:              selectedPayProcessors || null,
          enableMap:                 this.state.formData.enableMap,
          halal:                     this.state.formData.halal,
          lastKDays:                 this.state.formData.lastKDays,
          isViewFnb:                 this.state.formData.isViewFnb,
          permanentlyClosed:         this.state.formData.permanentlyClosed,
          isFastFood:                this.state.formData.isFastFood,
          isConvStore:               this.state.formData.isConvStore,
          isChainStore:              this.state.formData.isChainStore,
          isOfficial:                this.state.formData.isOfficial,
          prefixCode:                this.state.formData.prefixCode,
          giftEnabled:               this.state.formData.giftEnabled,
          showAllPostsInLowLevelMap: this.state.formData.showAllPostsInLowLevelMap,
          tagSearchInMapEnabled:     this.state.formData.tagSearchInMapEnabled,
          parentId:                  _.isEmpty(this.state.selectedParent) ? null : this.state.selectedParent.id,
        };

        page = await this.props.updatePage(this.props.match.params.id, payload);
        this.setState({ loading: false });
        toast.success('Page updated');

        const prevParentId = this.state.formData.parentId;
        this.setState({
          formData: {
            ...this.state.formData,
            parentId:    page.parentId,
            langZh:      Trim(page.langZh, false, true),
            description: page.description,
            facebook:    page.facebook,
            website:     page.website,
            prefixCode:  page.prefixCode,
            userTags:    page.userTags,
          },
        }, () => {
          if (this.state.isUpdate && !IsEmpty(this.state.formData.parentId) && prevParentId !== this.state.formData.parentId) {
            this.fetchParentData(this.state.formData.parentId);
          }
        });
      } else {
        const payload = {
          ...this.state.formData,
          name:                      nameTrimmed,
          langZh:                    langZhTrimmed,
          payProcessor:              selectedPayProcessors || null,
          website:                   links.website,
          facebook:                  links.facebook,
          instagram:                 links.instagram,
          userTags:                  this.state.formData.userTags,
          giftEnabled:               this.state.formData.giftEnabled,
          showAllPostsInLowLevelMap: this.state.formData.showAllPostsInLowLevelMap,
          tagSearchInMapEnabled:     this.state.formData.tagSearchInMapEnabled,
          parentId:                  _.isEmpty(this.state.selectedParent) ? null : this.state.selectedParent.id,
        };

        page = await this.props.addPage(payload);
        await this.props.updatePageStatus(page.id, Constants.PageStatus.Live);
        toast.success('Page created');
        this.setState({ loading: false, redirect: true, id: page.id });
      }
    } catch (err) {
      this.setState({ loading: false });
      toast.error(IsString(err) ? err : err.message);
    }
  };

  handleRedirectToParent = () => {
    this.setState({
      redirect: true,
      id:       this.state.formData.parentId,
    }, () => {
      window.location.reload();
    });
  }

  render() {
    if (this.state.redirect) { return (<Redirect to={`/admin/page/${this.state.id}`} />); }
    const { classes } = this.props;

    const mandatoryTags = [];

    if (!IsEmpty(this.state.formData.name)) {
      mandatoryTags.push(formatTag(this.state.formData.name));
    }

    if (!_.isEmpty(this.state.selectedParent) && !IsEmpty(this.state.selectedParent.label)) {
      mandatoryTags.push(formatTag(this.state.selectedParent.label));
    }

    return (
      <div>
        <form
          className="form position-relative"
          onSubmit={(e) => this.onSubmit(e)}
          autoComplete="off"
        >
          {this.state.loading && <OverLoading />}
          <div className="row">
            <div className="col-lg-6 col-sm-12 form-section">
              {this.state.isUpdate && !IsEmpty(this.state.formData.parentId) && !_.isEmpty(this.state.selectedParent)
              && (
                <div className="alert alert-primary d-flex justify-content-between align-items-center" role="alert">
                  <Typography>
                    This page is a child of
                    {' '}
                    <strong onClick={() => { this.handleRedirectToParent(); }}>{this.state.selectedParent.name}</strong>
                    {' '}
                    page
                  </Typography>

                  <Tooltip
                    title="Remove Parent Page"
                    placement="top"
                    classes={{ tooltipPlacementTop: 'm-0', tooltipPlacementBottom: 'm-0' }}
                  >
                    <IconButton
                      style={{ color: 'inherit' }}
                      size="small"
                      className="p-1"
                      onClick={() => this.setState({ isParentRemovalModalOpen: true })}
                    >
                      <CancelIcon color="inherit" />
                    </IconButton>
                  </Tooltip>
                </div>
              )}
              {this.state.isUpdate
                ? (
                  <div className="form-group">
                    <Typography>Name *</Typography>
                    <input
                      onKeyDown={(e) => this.preventSubmitOnEnter(e)}
                      type="text"
                      className="form-control"
                      name="name"
                      value={this.state.formData.name}
                      required
                      disabled
                    />
                  </div>
                )
                : (
                  <div className="form-group">
                    <Typography>Name *</Typography>
                    <input
                      onKeyDown={(e) => this.preventSubmitOnEnter(e)}
                      type="text"
                      className="form-control"
                      name="name"
                      value={this.state.formData.name}
                      onChange={(e) => this.onChange(e)}
                      autoFocus
                      required
                    />
                  </div>
                )}
              <div className="form-group mb-5">
                <Typography>Translations</Typography>
                <TextField
                  onKeyDown={(e) => this.preventSubmitOnEnter(e)}
                  id="outlined-basic"
                  label="Chinese (zh-SG)"
                  variant="outlined"
                  name="langZh"
                  value={this.state.formData.langZh}
                  className="form-control mt-2 mb-5"
                  onChange={(e) => this.onChange(e)}
                />
              </div>
              {
                this.state.isUpdate
                  ? (
                    <div className="form-group">
                      <Typography>Status</Typography>
                      <RadioGroup
                        row
                        aria-label="status"
                        name="status"
                        value={this.state.formData.status}
                      >
                        <FormControlLabel
                          value={Constants.PageStatus.Pending}
                          control={<Radio color="default" />}
                          label={Constants.PageStatus.Pending}
                        />
                        <FormControlLabel
                          value={Constants.PageStatus.Live}
                          control={<Radio color="primary" />}
                          label={Constants.PageStatus.Live}
                        />
                        <FormControlLabel
                          value={Constants.PageStatus.Rejected}
                          control={<Radio color="secondary" />}
                          label={Constants.PageStatus.Rejected}
                        />
                      </RadioGroup>
                    </div>
                  )
                  : null
              }
              {
                this.state.isUpdate && (
                  <div style={{ display: 'inline-block', width: 175 }}>
                    <FormGroup>
                      <FormControlLabel
                        control={(
                          <Checkbox
                            onChange={() => {
                        this.setState({ formData: {
                          ...this.state.formData,
                          permanentlyClosed: !this.state.formData.permanentlyClosed,
                        },
                        });
                            }}
                            name="permanently-closed"
                            checked={this.state.formData.permanentlyClosed}
                          />
                        )}
                        label="Permanently Closed"
                      />
                    </FormGroup>
                  </div>
                )
              }
              <div className="form-group">
                <Typography>Description</Typography>
                <textarea
                  className="form-control"
                  name="description"
                  value={this.state.formData.description}
                  onChange={(e) => this.onChange(e)}
                >
                  {this.state.formData.description}
                </textarea>
              </div>
              <div className="form-group">
                <Typography>Page type</Typography>
                <RadioGroup
                  row
                  aria-label="type"
                  name="type"
                  value={this.state.formData.type}
                  onChange={(e) => this.onChange(e)}
                >
                  <FormControlLabel
                    value={Constants.PageType.Retailer}
                    control={<Radio color="primary" />}
                    label={Constants.PageType.Retailer}
                    disabled={this.state.isUpdate}
                  />
                  <FormControlLabel
                    value={Constants.PageType.Mall}
                    control={<Radio color="primary" />}
                    label={Constants.PageType.Mall}
                    disabled={this.state.isUpdate}
                  />
                  <FormControlLabel
                    value={Constants.PageType.FNB}
                    control={<Radio color="primary" />}
                    label={Constants.PageType.FNB}
                    disabled={this.state.isUpdate}
                  />
                  <FormControlLabel
                    value={Constants.PageType.ECommerce}
                    control={<Radio color="primary" />}
                    label={Constants.PageType.ECommerce}
                    disabled={this.state.isUpdate}
                  />
                  <FormControlLabel
                    value={Constants.PageType.EventsCompany}
                    control={<Radio color="primary" />}
                    label={Constants.PageType.EventsCompany}
                    disabled={this.state.isUpdate}
                  />
                  <FormControlLabel
                    value={Constants.PageType.CreditCard}
                    control={<Radio color="primary" />}
                    label={Constants.PageType.CreditCard}
                    disabled={this.state.isUpdate}
                  />
                  <FormControlLabel
                    value={Constants.PageType.FoodReview}
                    control={<Radio color="primary" />}
                    label={Constants.PageType.FoodReview}
                    disabled={this.state.isUpdate}
                  />
                  <FormControlLabel
                    value={Constants.PageType.HawkerCentre}
                    control={<Radio color="primary" />}
                    label={Constants.PageType.HawkerCentre}
                    disabled={this.state.isUpdate}
                  />
                  <FormControlLabel
                    value={Constants.PageType.AreaManagement}
                    control={<Radio color="primary" />}
                    label={Constants.PageType.AreaManagement}
                    disabled={this.state.isUpdate}
                  />
                  <FormControlLabel
                    value={Constants.PageType.View}
                    control={<Radio color="primary" />}
                    label={Constants.PageType.View}
                    disabled={this.state.isUpdate}
                  />
                  <FormControlLabel
                    value={Constants.PageType.Photographer}
                    control={<Radio color="primary" />}
                    label={Constants.PageType.Photographer}
                    disabled={this.state.isUpdate}
                  />
                </RadioGroup>
              </div>
              {
                (this.state.formData.type === Constants.PageType.CreditCard)
                && (
                  <div className="form-group">
                    <Typography>Pay Processor</Typography>
                    <CheckboxGroup
                      payProcessor={this.state.formData.payProcessor}
                      onChange={(name) => {
                        this.setState((prev) => ({
                          formData: {
                            ...prev.formData,
                            payProcessor: {
                              ...prev.formData.payProcessor,
                              [name]: !prev.formData.payProcessor[name],
                            },
                          },
                        }));
                      }}
                    />
                  </div>
                )
              }
              {
                (this.state.formData.type === Constants.PageType.FNB
                  || this.state.formData.type === Constants.PageType.ECommerce
                  || this.state.formData.type === Constants.PageType.Retailer)
                && (
                  <div className="form-group">
                    <Typography>Halal</Typography>
                    <RadioGroup
                      row
                      aria-label="halal"
                      name="halal"
                      value={this.state.formData.halal}
                      onChange={(e) => this.onChange(e)}
                    >
                      <FormControlLabel
                        value={Constants.HalalStatus.No}
                        control={<Radio color="default" />}
                        label={Constants.HalalStatus.No}
                      />
                      <FormControlLabel
                        value={Constants.HalalStatus.HalalCertified}
                        control={<Radio color="primary" />}
                        label={Constants.HalalStatus.HalalCertified}
                      />
                      <FormControlLabel
                        value={Constants.HalalStatus.MuslimOwned}
                        control={<Radio color="primary" />}
                        label={Constants.HalalStatus.MuslimOwned}
                      />
                    </RadioGroup>
                  </div>
                )
              }
              <div className="form-group">
                {(!this.state.isUpdate || (this.state.isUpdate && IsEmpty(this.state.formData.parentId))) && (
                  <div>
                    <Typography>Parent Page</Typography>
                    <PageSuggestionField
                      disabled={this.state.isUpdate && !IsEmpty(this.state.formData.parentId)}
                      value={this.state.selectedParent}
                      onChange={this.handleChangeParentOptions}
                      apiParams={{ isParent: true }}
                    />
                  </div>
                )}
              </div>

              {
                (this.state.formData.type === Constants.PageType.Mall
                 || this.state.formData.type === Constants.PageType.HawkerCentre)
                && (
                  <div>
                    <div className="form-group">
                      <Typography>Postal Code</Typography>
                      <input
                        onKeyDown={(e) => this.preventSubmitOnEnter(e)}
                        className="form-control"
                        name="postalCode"
                        value={this.state.formData.postalCode}
                        onChange={(e) => this.onChangePostalCode(e)}
                      />
                    </div>
                    <div className="form-group">
                      <Typography>Address</Typography>
                      <input
                        onKeyDown={(e) => this.preventSubmitOnEnter(e)}
                        className="form-control"
                        name="address"
                        value={IsEmpty(this.state.formData.address) ? Constants.Error.PostalCodeIsInvalid : this.state.formData.address}
                        // onChange={e => this.onChange(e)}
                        disabled
                      />
                    </div>
                  </div>
                )
              }

              <div className="form-group">
                {this.state.formData.type !== Constants.PageType.Photographer && (
                  <>
                    <div className="d-block">
                      <FormGroup>
                        <FormControlLabel
                          control={(
                            <Checkbox
                              onChange={(e) => this.onChange(e)}
                              name="is-fast-food"
                              checked={this.state.formData.isFastFood}
                            />
                          )}
                          label="Is a fast food chain store"
                        />
                      </FormGroup>
                    </div>

                    <div className="d-block">
                      <FormGroup>
                        <FormControlLabel
                          control={(
                            <Checkbox
                              onChange={(e) => this.onChange(e)}
                              name="is-conv-store"
                              checked={this.state.formData.isConvStore}
                            />
                          )}
                          label="Is a convenient store"
                        />
                      </FormGroup>
                    </div>
                  </>
                )}

                {this.state.formData.type === Constants.PageType.FNB && (
                  <div className="d-block">
                    <FormGroup>
                      <FormControlLabel
                        control={(
                          <Checkbox
                            onChange={(e) => this.onChange(e)}
                            name="is-chain-store"
                            checked={this.state.formData.isChainStore}
                          />
                        )}
                        label="Is a chain store brand"
                      />
                    </FormGroup>
                  </div>
                )}

                <div className="d-block">
                  <FormGroup>
                    <FormControlLabel
                      control={(
                        <Checkbox
                          onChange={(e) => this.onChange(e)}
                          name="is-official"
                          checked={this.state.formData.isOfficial}
                        />
                      )}
                      label="Is official"
                    />
                  </FormGroup>
                </div>
              </div>

              { ![
                Constants.PageType.Mall,
                Constants.PageType.CreditCard,
                Constants.PageType.AreaManagement,
              ].includes(this.state.formData.type)
                ? (
                  <div className="form-group">
                    <Typography>Category *</Typography>
                    <Autocomplete
                      limitTags={20}
                      multiple
                      id="tags-outlined"
                      options={this.state.categoryOptions}
                      getOptionSelected={(option, value) => value.value === option.value}
                      disableCloseOnSelect
                      disablePortal
                      noOptionsText="Category is not available."
                      value={this.state.selectedCategoryOptions}
                      onChange={(e, values) => {
                      this.handleChangeCategoryOptions(values);
                      }}
                      renderTags={(value, getTagProps) => value.map((option, index) => (
                        <Chip variant="outlined" label={option.label} {...getTagProps({ index })} />
                      ))}
                      groupBy={(option) => option.group}
                      getOptionLabel={(option) => option.label}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                        />
                      )}
                    />
                  </div>
                ) : ''}

              <div className="form-group">
                <Typography>Prefix code</Typography>
                <input
                  onKeyDown={(e) => this.preventSubmitOnEnter(e)}
                  className="form-control"
                  name="prefixCode"
                  value={this.state.formData.prefixCode}
                  onChange={(e) => this.onPrefixCodeChange(e)}
                />
              </div>

              <div className="form-group">
                <Typography style={{ display: 'inline-block' }}>Website</Typography>
                {(!IsEmpty(this.state.formData.website)) ? (
                  <Button
                    onClick={() => {
                      const url = this.state.formData.website;
                      const fullUrl = url.startsWith('http://') || url.startsWith('https://')
                        ? url
                        : `http://${url}`;
                      window.open(fullUrl, '_blank');
                    }}
                    target="_blank"
                    variant="outlined"
                    color="secondary"
                    style={{ border: `1px solid ${Colours.Primary}` }}
                    size="medium"
                    className="d-inline-block mb-2 ml-5"
                  >
                    <span style={{ color: Colours.Primary, marginRight: 5 }}>Open Link</span>
                    <LaunchIcon style={{ color: Colours.Primary }} />
                  </Button>
                ) : ''}
                <input
                  onKeyDown={(e) => this.preventSubmitOnEnter(e)}
                  className="form-control"
                  name="website"
                  placeholder="www.example.com"
                  value={this.state.formData.website}
                  onChange={(e) => this.onChange(e)}
                />
              </div>
              <div className="form-group">
                <SocialLinkInput
                  title="Facebook"
                  state={this.state.formData.facebook}
                  onClick={() => this.setState({ openFacebookModal: true })}
                  onChange={(e) => this.onChange(e)}
                />
              </div>
              <div className="form-group">
                <SocialLinkInput
                  title="Instagram"
                  state={this.state.formData.instagram}
                  onClick={() => this.setState({ openInstagramModal: true })}
                  onChange={(e) => this.onChange(e)}
                />
              </div>
              <div className="form-group">
                <Typography>Tags</Typography>
                <Tagging
                  textSize="h6"
                  onKeyDown={(e) => this.preventSubmitOnEnter(e)}
                  data={[...this.state.formData.userTags].map((tag) => ({ name: tag, removable: mandatoryTags.includes(tag) }))}
                  onChange={(values) => {
                    const formattedUserTags = values.map((value) => formatTag(value));
                    this.setState({ formData: { ...this.state.formData, userTags: formattedUserTags } });
                  }}
                />
              </div>

              {
                this.state.formData.type === Constants.PageType.View && (
                  <>
                    <div className="form-group">
                      <Typography>Show all posts in low-level map</Typography>
                      <RadioGroup
                        row
                        aria-label="type"
                        name="showAllPostsInLowLevelMap"
                        value={this.state.formData.showAllPostsInLowLevelMap}
                      >
                        <FormControlLabel
                          onChange={() => this.onChangeShowAllPostsInLowLevelMap(false)}
                          value={false}
                          control={<Radio color="primary" checked={!this.state.formData.showAllPostsInLowLevelMap} />}
                          label="No"
                        />
                        <FormControlLabel
                          onChange={() => this.onChangeShowAllPostsInLowLevelMap(true)}
                          value
                          control={<Radio color="primary" checked={this.state.formData.showAllPostsInLowLevelMap} />}
                          label="Yes"
                        />
                      </RadioGroup>
                    </div>

                    <div className="form-group">
                      <Typography>Enable tag search in map</Typography>
                      <RadioGroup
                        row
                        aria-label="type"
                        name="tagSearchInMapEnabled"
                        value={this.state.formData.tagSearchInMapEnabled}
                      >
                        <FormControlLabel
                          onChange={() => this.onChangeTagSearchInMapEnabled(false)}
                          value={false}
                          control={<Radio color="primary" checked={!this.state.formData.tagSearchInMapEnabled} />}
                          label="No"
                        />
                        <FormControlLabel
                          onChange={() => this.onChangeTagSearchInMapEnabled(true)}
                          value
                          control={<Radio color="primary" checked={this.state.formData.tagSearchInMapEnabled} />}
                          label="Yes"
                        />
                      </RadioGroup>
                    </div>
                  </>
                )
              }

              <div className="form-group">
                <Typography>Enable Gift</Typography>
                <RadioGroup
                  row
                  aria-label="type"
                  name="enableMap"
                  value={this.state.formData.giftEnabled}
                >
                  <FormControlLabel
                    onChange={() => this.onChangeGiftEnabled(false)}
                    value={false}
                    control={<Radio color="primary" checked={!this.state.formData.giftEnabled} />}
                    label="No"
                  />
                  <FormControlLabel
                    onChange={() => this.onChangeGiftEnabled(true)}
                    value
                    control={<Radio color="primary" checked={this.state.formData.giftEnabled} />}
                    label="Yes"
                  />
                </RadioGroup>
              </div>

              {[PageType.View, PageType.AreaManagement].includes(this.state.formData.type) && (
                <>
                  <div className="form-group">
                    <Typography>Enable Map</Typography>
                    <RadioGroup
                      row
                      aria-label="type"
                      name="enableMap"
                      value={this.state.formData.enableMap}
                    >
                      <FormControlLabel
                        onChange={() => this.onChangeEnableMap(false)}
                        value={false}
                        control={<Radio color="primary" checked={!this.state.formData.enableMap} />}
                        label="No"
                      />
                      <FormControlLabel
                        onChange={() => this.onChangeEnableMap(true)}
                        value
                        control={<Radio color="primary" checked={this.state.formData.enableMap} />}
                        label="Yes"
                      />
                    </RadioGroup>
                  </div>
                </>
              )}

              {(this.state.formData.type === PageType.View) && (
                <>
                  <div className="form-group">
                    <span>Display posts that will expire in</span>
                    <div style={{ paddingLeft: 0, marginLeft: 0 }}>
                      <Checkbox
                        checked={this.state.isHasKDays || false}
                        onChange={(e) => this.onChangeKDaysCheckBox(e)}
                        style={{ paddingLeft: 0, marginLeft: 0 }}
                      />
                      <input
                        onKeyDown={(e) => this.preventSubmitOnEnter(e)}
                        type="text"
                        style={{ width: '30px', borderBottomWidth: 2, borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, outline: 'none' }}
                        name="lastKDays"
                        value={this.state.formData.lastKDays || ''}
                        onChange={(e) => this.onChange(e)}
                      />
                      <span> day(s)</span>
                    </div>
                    <div style={{ marginLeft: '20px' }}>
                      <p>* Enter &apos;1&apos; for last day</p>
                      <p>* Enter &apos;3&apos; (for e.g) for last 3 days, i.e today and the next 2 days</p>
                    </div>
                  </div>

                  <div className="form-group mt-4">
                    <Typography>Is F&#38;B</Typography>
                    <RadioGroup
                      row
                      aria-label="type"
                      name="isViewFnb"
                      value={this.state.formData.isViewFnb}
                    >
                      <FormControlLabel
                        onChange={() => this.onChangeIsViewFnb(false)}
                        value={false}
                        control={<Radio color="primary" checked={!this.state.formData.isViewFnb} />}
                        label="No"
                      />
                      <FormControlLabel
                        onChange={() => this.onChangeIsViewFnb(true)}
                        value
                        control={<Radio color="primary" checked={this.state.formData.isViewFnb} />}
                        label="Yes"
                      />
                    </RadioGroup>
                  </div>
                </>
              )}
            </div>

            {this.state.isUpdate
              ? (
                <div className="col-lg-6 col-sm-12 image-section">
                  <Typography>
                    Logo (Res min=
                    {this.minLogoRes}
                    x
                    {this.minLogoRes}
                    {' '}
                    max=
                    {this.maxLogoRes}
                    x
                    {this.maxLogoRes}
                    . File size max=3mb)
                  </Typography>
                  {this.state.formData.logo
                    ? (
                      <div className="pl-5">
                        <img
                          style={{
                            borderRadius: '100%',
                            width:        '200px',
                            height:       '200px',
                          }}
                          src={this.state.formData.logo}
                          alt=""
                        />
                        <div style={{
                          width:  '50%',
                          height: '50px',
                        }}
                        >
                          <IconButton
                            onClick={() => { this.setState({ alert: true }); }}
                            className="float-right"
                            style={{
                              backgroundColor: '#ffffff',
                              boxShadow:       '0 1px 2px 1px rgba(0, 0, 0, .1)',
                              verticalAlign:   'bottom',
                              margin:          '10px 0px 0px 0px',
                            }}
                          >
                            <DeleteOutlineIcon />
                          </IconButton>
                        </div>
                      </div>
                    ) : ''}
                  {!this.state.formData.logo
                    ? (
                      <DropzoneArea
                        dropzoneText=""
                        onChange={this.handleUpload}
                        dropzoneClass={classes.myDropZone}
                        showPreviewsInDropzone={false}
                        showPreviews={false}
                        showAlerts={false}
                        filesLimit={1}
                        maxFileSize={3000000}
                        acceptedFiles={['image/jpg', 'image/jpeg', 'image/png']}
                      />
                    ) : ''}
                </div>
              ) : ''}
          </div>
          <div className="row">
            <div className="col-lg-4 col-sm-12" />
            <div className="col-lg-2 col-sm-12">
              <div className="form-group">
                <input
                  onKeyDown={(e) => this.preventSubmitOnEnter(e)}
                  type="submit"
                  disabled={this.state.loading}
                  className={`btn block ${this.state.loading ? 'btn-secondary' : 'btn-primary'}`}
                  value={this.state.isUpdate ? 'Update' : 'Save'}
                  onMouseDown={(e) => { e.preventDefault(); }}
                />
              </div>
            </div>
          </div>
        </form>

        {this.state.isParentRemovalModalOpen
        && (
          <Modal isOpen={this.state.isParentRemovalModalOpen} style={{ minWidth: 600, margin: '8rem auto' }}>
            <ModalHeader>
              Remove Parent Page
            </ModalHeader>
            <ModalBody>
              <Typography>
                {'Are you sure you want to remove parent page '}
                <strong>{`\`${this.state.selectedParent.label}\``}</strong>
                {' from child page '}
                <strong>{`\`${this.state.formData.name}\``}</strong>
                ?
              </Typography>
            </ModalBody>
            <ModalFooter>
              <Button
                disableElevation
                variant="contained"
                className="mr-3"
                style={{ textTransform: 'none', fontWeight: 400, backgroundColor: Colours.Crimson, color: Colours.White }}
                onClick={this.removeParentPage}
              >
                Remove
              </Button>
              <Button
                disableElevation
                variant="contained"
                className="mr-2"
                style={{ textTransform: 'none', fontWeight: 400, backgroundColor: '#6C757D', color: Colours.White }}
                onClick={() => this.setState({ isParentRemovalModalOpen: false })}
              >
                Cancel
              </Button>
            </ModalFooter>
          </Modal>
        )}

        <Dialog
          fullScreen
          open={this.state.openCropDialog}
          onClose={() => { this.handleClose(); }}
        >
          <FixedCropper
            label="Logo"
            width={1}
            height={1}
            minUploadPixelWidth={this.minLogoRes}
            minUploadPixelHeight={this.minLogoRes}
            cropPixelWidth={this.minLogoRes}
            cropPixelHeight={this.minLogoRes}
            outputPixelWidth={this.minLogoRes}
            outputPixelHeight={this.minLogoRes}
            type={this.state.type}
            url={this.state.uploadUrl}
            src={this.state.src}
            file={this.state.currentFile}
            handleSave={this.handleSave}
            handleClose={this.handleClose}
          />
        </Dialog>

        <Dialog
          open={this.state.alert}
          onClose={() => { this.handleClose(); }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Remove Logo</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete the logo?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => { this.handleClose(); }} color="primary">Cancel</Button>
            <Button onClick={() => { this.handleDelete(); }} color="primary">Confirm</Button>
          </DialogActions>
        </Dialog>

        <SocialLinksModal
          title="Facebook"
          state={this.state.formData.facebook}
          toggleOff={() => this.setState({ openFacebookModal: false })}
          open={this.state.openFacebookModal}
        />

        <SocialLinksModal
          title="Instagram"
          state={this.state.formData.instagram}
          toggleOff={() => this.setState({ openInstagramModal: false })}
          open={this.state.openInstagramModal}
        />
      </div>
    );
  }
}

pageInfo.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    id: PropTypes.string,
  }).isRequired,

  classes: PropTypes.shape({
    myDropZone: PropTypes.string,
  }).isRequired,

  addPage:       PropTypes.func.isRequired,
  getAddress:    PropTypes.func.isRequired,
  getCategories: PropTypes.func.isRequired,
  getPage:       PropTypes.func.isRequired,

  updatePage:       PropTypes.func.isRequired,
  updatePageStatus: PropTypes.func.isRequired,

  uploadPageImage: PropTypes.func.isRequired,
  deletePageImage: PropTypes.func.isRequired,
};

SocialLinkInput.propTypes = {
  title:    PropTypes.string.isRequired,
  state:    PropTypes.string.isRequired,
  onClick:  PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

SocialLinksModal.propTypes = {
  title:     PropTypes.string.isRequired,
  state:     PropTypes.string.isRequired,
  toggleOff: PropTypes.func.isRequired,
  open:      PropTypes.bool.isRequired,
};

CheckboxGroup.propTypes = {
  payProcessor: PropTypes.objectOf(PropTypes.object).isRequired,
  onChange:     PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  getPage,
  addPage,
  getCategories,
  uploadPageImage,
  deletePageImage,
  getAddress,
  updatePage,
  updatePageStatus,
};
export default connect(null, mapDispatchToProps)(withStyles(useStyles)(pageInfo));
